import { render, staticRenderFns } from "./PermitModal.vue?vue&type=template&id=b79e843e&"
import script from "./PermitModal.vue?vue&type=script&lang=js&"
export * from "./PermitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports